const PaperIcon = () => {
  return (
    <svg
      width="20"
      height="26"
      viewBox="0 0 20 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8713 5.78799H15.1643C14.568 5.78799 14.0845 5.31496 14.0845 4.73145V1.10439L18.8713 5.78799Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.05654C0 0.473028 0.483448 0 1.07981 0H12.4883V4.73145C12.4883 6.17754 13.6864 7.34982 15.1643 7.34982H20V24.9435C20 25.527 19.5166 26 18.9202 26H1.07981C0.483448 26 0 25.527 0 24.9435V1.05654ZM3.56808 13C3.56808 12.5687 3.92541 12.2191 4.3662 12.2191H14.6948C15.1356 12.2191 15.493 12.5687 15.493 13C15.493 13.4313 15.1356 13.7809 14.6948 13.7809H4.3662C3.92541 13.7809 3.56808 13.4313 3.56808 13ZM3.56808 16.2155C3.56808 15.7843 3.92541 15.4346 4.3662 15.4346H14.6948C15.1356 15.4346 15.493 15.7843 15.493 16.2155C15.493 16.6468 15.1356 16.9965 14.6948 16.9965H4.3662C3.92541 16.9965 3.56808 16.6468 3.56808 16.2155ZM3.56808 19.4311C3.56808 18.9998 3.92541 18.6502 4.3662 18.6502H14.6948C15.1356 18.6502 15.493 18.9998 15.493 19.4311C15.493 19.8624 15.1356 20.212 14.6948 20.212H4.3662C3.92541 20.212 3.56808 19.8624 3.56808 19.4311Z"
        fill="white"
      />
    </svg>
  );
};

export default PaperIcon;
